import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DrWeedyLogo from "../assets/DrWeedyLogo";
import SubscriptionSection from "../components/SubscriptionSection";

const containerSx = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #1a313c 0%, #04090a 100%)",
  color: "#ffffff",
  fontFamily: "Inter, system-ui, sans-serif",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "24px",
};

const ghostBtnSx = {
  color: "rgba(255,255,255,0.85)",
  borderColor: "rgba(255,255,255,0.25)",
  borderRadius: "14px",
  textTransform: "none",
};

export default function AccountPage() {
  const navigate = useNavigate();

  return (
    <Box sx={containerSx}>
      <Box sx={{ width: "100%", maxWidth: 560, mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <DrWeedyLogo />
        <Button sx={ghostBtnSx} variant="outlined" onClick={() => navigate("/chat")}>
          Voltar ao chat
        </Button>
      </Box>

      <Box sx={{ width: "100%", maxWidth: 560 }}>
        <SubscriptionSection />
      </Box>
    </Box>
  );
}
